export const jobTypesUtil = [
    {Code: 'Full-time', Name: 'Full-time'},
    {Code: 'Contract', Name: 'Contract'},
    {Code: 'Internship & Graduate', Name: 'Internship & Graduate'},
    {Code: 'Part Time', Name: 'Part Time'}
];

export const workModeUtil = [
    {Code: 'Onsite', Name: 'Onsite'},
    {Code: 'Hybrid', Name: 'Hybrid'},
    {Code: 'Remote', Name: 'Remote'}
];

export const qualificationUtil = [
    {Code: 'Degree', Name: 'Degree'},
    {Code: 'Diploma', Name: 'Diploma'},
    {Code: 'High School (S.S.C.E)', Name: 'High School (S.S.C.E)'},
    {Code: 'HND', Name: 'HND'},
    {Code: 'MBA / MSc', Name: 'MBA / MSc'},
    {Code: 'MBBS', Name: 'MBBS'},
    {Code: 'MPhil / PhD', Name: 'MPhil / PhD'},
    {Code: 'N.C.E', Name: 'N.C.E'},
    {Code: 'OND', Name: 'OND'},
    {Code: 'Vocational', Name: 'Vocational'},
    {Code: 'Others', Name: 'Others'},
];

export const experienceLevelUtil = [
    {Code: 'No Experience', Name: 'No Experience'},
    {Code: 'Internship & Graduate', Name: 'Internship & Graduate'},
    {Code: 'Entry Level', Name: 'Entry Level'},
    {Code: 'Mid Level', Name: 'Mid Level'},
    {Code: 'Senior Level', Name: 'Senior Level'},
    {Code: 'Executive Level', Name: 'Executive Level'}
];

export const experienceLengthUtil = [
    {Code: 'Less than 1 Year', Name: 'Less than 1 Year'},
    {Code: '1 Year', Name: '1 Year'},
    {Code: '2 Years', Name: '2 Years'},
    {Code: '3 Years', Name: '3 Years'},
    {Code: '4 Years', Name: '4 Years'},
    {Code: '5 Years', Name: '5 Years'},
    {Code: '6 Years', Name: '6 Years'},
    {Code: '7 Years', Name: '7 Years'},
    {Code: '8 Years', Name: '8 Years'},
    {Code: '9 Years', Name: '9 Years'},
    {Code: '10 Years', Name: '10 Years'},
    {Code: '11 Years', Name: '11 Years'},
    {Code: '12 Years', Name: '12 Years'},
    {Code: '13 Years', Name: '13 Years'},
    {Code: '14 Years', Name: '14 Years'},
    {Code: '15 Years', Name: '15 Years'},
    {Code: '16 Years', Name: '16 Years'},
    {Code: '17 Years', Name: '17 Years'},
    {Code: '18 Years', Name: '18 Years'},
    {Code: '19 Years', Name: '19 Years'},
    {Code: '20 Years', Name: '20 Years'},
    {Code: 'More than 20 Years', Name: 'More than 20 Years'},
];

export const availabilityUtil = [
    {Code: 'Immediately', Name: 'Immediately'},
    {Code: '1 Week', Name: '1 Week'},
    {Code: '2 Weeks', Name: '2 Weeks'},
    {Code: '3 Weeks', Name: '3 Weeks'},
    {Code: '1 Month', Name: '1 Month'},
    {Code: '2 Months', Name: '2 Months'},
    {Code: '3 Months', Name: '3 Months'},
    {Code: 'More Than 3 Months', Name: 'More Than 3 Months'},
];